<template>
    <router-view />
</template>

<script>

import './style.css'

import { mapMutations } from 'vuex'

export default {
    name: 'leasing',
    methods: {}
}
</script>